export default __webpack_public_path__ + "static/media/8.2d2d8021.jpg";